import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { getFirstAvailableTopLevelSectionRoute } from '@/configs/organizationSectionsRouting';
import { ROUTES } from '@/configs/routes';
import { useOrganizationSectionsStore } from '@/stores/local/shared/OrganizationSectionsStore';

type NavigateToOrganizationHomeOptions = {
  organizationId: string;
  isPhone: boolean;
  replace?: boolean;
  withResetChatState?: boolean;
};

export const useNavigateToOrganizationHome = () => {
  const navigate = useNavigate();
  const sectionsStore = useOrganizationSectionsStore();

  return React.useCallback(
    ({
      organizationId,
      isPhone,
      replace = true,
      withResetChatState = true,
    }: NavigateToOrganizationHomeOptions): string => {
      const target =
        getFirstAvailableTopLevelSectionRoute({
          enabledSections: sectionsStore.enabledTopLevelSections,
          organizationId,
          isPhone,
        }) ?? ROUTES.root.path;

      if (target === ROUTES.root.path || !withResetChatState) {
        navigate(target, { replace });

        return target;
      }

      navigate(target, { replace, state: { resetChat: true } });

      return target;
    },
    [navigate, sectionsStore.enabledTopLevelSections],
  );
};
